import ActionValueModel from "./ActionValueModel";

export default class ActionsModel {
    public value: ActionValueModel[] = [new ActionValueModel()]
}